import { Button } from '@/components/ui/button';
import { HeaderDashboard } from '@/components/shared/header-dashboard';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ProfileInfo } from '@/features/consumer/profile-info';
import { SavedAddress } from '@/features/consumer/saved-address';
import { DeleteAccountButton } from '@/features/consumer/delete-user-me-button';
export const Route = createFileRoute('/(consumer)/_authenticated/view-profile')(
  {
    component: ViewProfilePage,
  }
);

function ViewProfilePage() {
  const navigate = useNavigate();
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.Title>View profile</HeaderDashboard.Title>
        <HeaderDashboard.Action>
          <Button
            size="sm"
            variant="secondary"
            onClick={() => navigate({ to: '/edit-profile' })}
          >
            Edit profile
          </Button>
        </HeaderDashboard.Action>
      </HeaderDashboard>

      <div className="flex flex-col gap-6">
        <ProfileInfo />
        <SavedAddress />
        <div className="flex justify-end">
          <DeleteAccountButton />
        </div>
      </div>
    </div>
  );
}
